module.exports = __webpack_public_path__ + "static/media/soumya_pachpor.c4560992.png";